import { useAlarmGroupDetails } from '@hakimo-ui/hakimo/data-access';
import {
  AlarmGroupContainer,
  InvestigationViewSkeleton,
} from '@hakimo-ui/hakimo/feature-shared';
import { SOPViewType, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { NotFound } from '@hakimo-ui/hakimo/ui-elements';
import { PageLayout } from '@hakimo-ui/hakimo/ui-layout';
import { withAuthz, withErrorBoundary } from '@hakimo-ui/hakimo/util';
import { useParams } from 'react-router-dom';
import { ALARM_GROUP_QUERY_INTERVAL } from '../alarm-groups-list/constants';
import { useTemporaryResolvedState } from '../hooks/useTemporaryResolvedState';

type Params = {
  alarmGroupId: string;
};

interface Props {
  alarmGroupId: string;
}

function AlarmGroupDetailsData(props: Props) {
  const { alarmGroupId } = props;
  const { addTemporaryResolvedState, getDisplayStatus } =
    useTemporaryResolvedState();

  const { data, error, isLoading } = useAlarmGroupDetails(
    alarmGroupId,
    undefined,
    false,
    ALARM_GROUP_QUERY_INTERVAL
  );

  if (isLoading) {
    return <InvestigationViewSkeleton />;
  }

  if (error) {
    return <NotFound message="Error loading alarm group details" />;
  }

  if (!data) {
    return <NotFound message="Alarm group not found" />;
  }

  return (
    <AlarmGroupContainer
      alarmGroup={data}
      product={data.product ?? UnifiedMonitoringProduct.SCAN}
      sopViewType={SOPViewType.STATIC}
      addTemporaryResolvedState={addTemporaryResolvedState}
      getDisplayStatus={getDisplayStatus}
    />
  );
}

function AlarmGroupDetailsRoot() {
  const { alarmGroupId } = useParams<Params>();

  if (alarmGroupId === undefined) {
    return <NotFound />;
  }

  return (
    <PageLayout title="Alarm Group Details" variant="single">
      <PageLayout.Content>
        <AlarmGroupDetailsData alarmGroupId={alarmGroupId} />
      </PageLayout.Content>
    </PageLayout>
  );
}

export default withAuthz(withErrorBoundary(AlarmGroupDetailsRoot), [
  'alarm_group/detail:view',
]);
